function Vision() {
    return (
        <div className="flex flex-col gap-4 lg:gap-8 xl:gap-12 px-[5vw] xl:px-[8vw]">
            <h1 className='font-semibold uppercase'>Notre vision pour l'avenir</h1>
            <div className="flex flex-col gap-4 lg:gap-8 xl:gap-12 pb-[5vh] text-justify text-brun-contrast">
                <p>Chez MENUITEK, nous voyons chaque projet comme une opportunité de bâtir plus qu’une simple ouverture : un lien durable entre confort, esthétique et performance.
                <br/>Notre ambition est de devenir une référence en menuiserie sur mesure, alliant innovation, design et respect de l’environnement, pour créer des espaces durables qui traversent le temps.</p>
                <p>Nous travaillons chaque jour à développer des solutions toujours plus performantes, à réduire notre impact environnemental, et à anticiper les besoins des générations futures.</p>
            </div>
        </div>
    )
}

export default Vision;